import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MasterData } from 'app/models/admin/master-data.model';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class MasterDataService {
    constructor(
        private _httpClient: HttpClient,
    ) { }

    getMasterData(): Observable<any> {
        return this._httpClient.get(environment.apiBaseUrl + '/master-data/');
    }

    addMasterData(data: MasterData): Observable<any> {
        return this._httpClient.post(environment.apiBaseUrl + '/master-data/', data);
    }

    updateMasterDataById(id: string, data: MasterData): Observable<any> {
        return this._httpClient.put(environment.apiBaseUrl + '/master-data/' + id, data);
    }

    scrapeProduct(): Observable<any> {
        return this._httpClient.get(environment.apiBaseUrl + '/master-data/scrape-product');
    }

    getNjourImageUrl(): Observable<any> {
        return this._httpClient.get(environment.apiBaseUrl + '/master-data/njour-image');
    }
}
